module.exports = __webpack_public_path__ + "static/img/db.80e31b21.png";